// extracted by mini-css-extract-plugin
export var body = "_io-8";
export var button = "_io-0";
export var closeButton = "_io-5";
export var content = "_io-3";
export var empty = "_io-f";
export var grid = "_io-c";
export var header = "_io-4";
export var icon = "_io-1";
export var option = "_io-d";
export var optionSelected = "_io-e";
export var overlay = "_io-2";
export var searchIcon = "_io-a";
export var searchInput = "_io-b";
export var searchWrapper = "_io-9";
export var title = "_io-6";
export var visuallyHidden = "_io-7";